import axios, { AxiosInstance } from 'axios';
import config from '.';

// Base URL
const api = (): AxiosInstance => axios.create({
  baseURL: config.apiUrl,
});

export default api;
